import dompurify from "isomorphic-dompurify";

import { useTranslations } from "@jti/ui";

const { sanitize } = dompurify;

type OrderSummaryPageWarningMessageType = {
  isFreeTrial: boolean;
  className: string;
};

export const OrderSummaryPageWarningMessage = ({ isFreeTrial, className }: OrderSummaryPageWarningMessageType) => {
  const { __ } = useTranslations();

  if (!isFreeTrial) {
    return null;
  }

  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{ __html: sanitize(__("cart.payment_summary.trial.infoText")) }}
    />
  );
};
